// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-c-input {
  cursor: pointer;
}

input:focus {
  margin: 0px !important;
}

.custom-inline-block {
  display: inline-block;
}

.custom-no-margin {
  margin-bottom: 0rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/date-picker/date-picker.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[".em-c-input {\n  cursor: pointer;\n}\n\ninput:focus {\n  margin: 0px !important;\n}\n\n.custom-inline-block {\n  display: inline-block;\n}\n\n.custom-no-margin {\n  margin-bottom: 0rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
